module.exports = __webpack_public_path__ + "static/media/arrow_left.cfd59a83.svg";